export const WIX_PROTOCOL = 'wix:';
export const SDKRequestToRESTRequestRenameMap = {
    _id: 'id',
    _createdDate: 'createdDate',
    _updatedDate: 'updatedDate',
};
export const RESTResponseToSDKResponseRenameMap = {
    id: '_id',
    createdDate: '_createdDate',
    updatedDate: '_updatedDate',
};
export const ITEMS_RESULT_PROPERTY_NAME = 'items';
export const PAGING_METADATA_RESULT_PROPERTY_NAME = 'pagingMetadata';
export const DEFAULT_LIMIT = 50;
